module.exports = __webpack_public_path__ + "img/floorplan-not-found.ae74ca89.svg";